// @core/api/endpoints/platform/update_platform_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformMemberResponse,
  UpdatePlatformMemberRoleRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update member role in platform
 * Changes a member's role within the platform. Role changes take effect immediately and modify the member's permissions across all platform resources.
 */
export async function UpdatePlatformMemberRole(
  platform_id: string,
  profile_id: string,
  data: UpdatePlatformMemberRoleRequest,
  options?: RequestOptions
): Promise<PlatformMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/members/:profile_id/role`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<PlatformMemberResponse>(requestPath, data, requestOptions);
}
